/**
 * GraphQL mutation for updating the production version of a community prompt
 */

import { gql } from '@apollo/client';

export const UPDATE_PROMPT_PROD_VERSION = gql`
  mutation UpdatePromptProdVersion($communityId: ID!, $input: UpdatePromptProdVersionInput!) {
    updatePromptProdVersion(communityId: $communityId, input: $input) {
      success
      message
    }
  }
`;
